<script lang="ts">
	import type { i18n } from 'types/common'

	import { graphql } from '$houdini'
	import Button from '@isoftdata/svelte-button'
	import Icon from '@isoftdata/svelte-icon'
	import Popover from '@isoftdata/svelte-popover'

	import session from 'stores/session'
	import { getContext } from 'svelte'

	interface Props {
		storeId: number | null

		sku: number | null
	}

	let { sku, storeId }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')

	const ecommerceStatusQuery = graphql(`
		query PartEcommerceStatus($sku: Int!, $storeId: Int!) {
			inventoryBySkuAndStore(sku: $sku, storeId: $storeId) {
				ecommerceStatus: htpAvailability {
					details
					listed
					recommendation
				}
			}
		}
	`)

	async function getEcommerceStatus() {
		if (sku && storeId) {
			const { data } = await ecommerceStatusQuery.fetch({
				variables: {
					sku,
					storeId,
				},
			})
			return data?.inventoryBySkuAndStore?.ecommerceStatus ?? null
		}
		return null
	}

	const ecommerceStatus = $derived(getEcommerceStatus())
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class="btn-group btn-group-sm"
	onclick={e => e.stopPropagation()}
>
	<Button
		outline
		size="sm"
		href="https://www.heavytruckparts.net/item/-/-/-/{$session.companyCode}/{storeId}/{sku}"
		target="htp_eew_popout"
		disabled={!storeId || !sku || !$session.companyCode}
		icon={{
			prefix: 'fak',
			class: 'fa-isoft-bolt',
		}}>{translate('HTPstuff.viewOnHeavytruckpartsNet', 'View on HeavyTruckParts.net')}</Button
	>
	{#await ecommerceStatus}
		<Button
			outline
			isLoading
			icon="spinner"
			size="sm"
		></Button>
	{:then ecommerceStatus}
		{@const listed = ecommerceStatus?.listed}
		<Popover
			outline
			disabled={!storeId || !sku}
			color={listed ? 'primary' : 'danger'}
			icon={listed ? 'circle-info' : 'triangle-exclamation'}
		>
			{#snippet header()}
				<Icon
					fixedWidth
					class={listed ? 'text-success' : 'text-danger'}
					icon={listed ? 'check' : 'xmark-large'}
				></Icon>
				{ecommerceStatus?.details ?? translate('HTPstuff.listedSuccessfully', 'Listed Successfully')}
			{/snippet}
			{#snippet body()}
				{ecommerceStatus?.recommendation ??
					translate(
						'HTPstuff.thisPartIsSuccessfullyListedOnHeavytruckpartsNet',
						'This part is successfully listed on HeavyTruckParts.net',
					)}
			{/snippet}
		</Popover>
	{/await}
</div>
